const Inputs = {
  baseStyle: {},
  variants: {
    standard: {
      field: {
        borderRadius: 100,
      },
      addon: {
        borderRadius: 100,
      },
      background: "white",
      borderRadius: "sm",
    },
    standardAddon: {
      addon: {
        p: 2,
        borderRadius: "lg",
        bg: "Gray.200",
        fontWeight: "bold",
      },
      field: {
        bg: "Gray.200",
        padding: "lg",
        borderRadius: "lg",
      },
    },
    primary: {
      background: "white",
      borderRadius: "sm",
      borderColor: "Gray.200",
      field: {
        bg: "Gray.100",
      },
    },
    filter: {
      field: {
        maxH: 6,
        p: 1,
        bg: "Gray.100",
        borderStyle: "none",
        borderRadius: "base",
      },
    },
    standardMdl: {
      field: {
        bg: "Gray.100",
        borderRadius: "md",
      },
    },
    account: {
      field: {
        color: "white",
        opacity: "95%",
        fontSize: "xl",
        borderRadius: "none",
        bg: "transparent",
        pt: 1,
        pb: 1,
        pl: 0,
        borderStyle: "solid",
        borderColor: "white",
        borderWidth: "0 0 1px 0",
        _placeholder: {
          color: "white",
          opacity: "75%",
        },
      },
      addon: {
        color: "white",
        opacity: "95%",
        fontSize: "xl",
        borderRadius: "none",
        bg: "transparent",
        p: 0,
        borderStyle: "solid",
        borderColor: "white",
        borderWidth: "0 0 1px 0",
      },
    },
  },
}

export default Inputs
